<div class="container">
  <router-outlet></router-outlet>
</div>
<app-custom-notifications></app-custom-notifications>
